var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vsm-menu", {
    staticClass: "mb-10",
    attrs: {
      menu: _vm.menu,
      "base-width": 380,
      "base-height": 400,
      "screen-offset": 10,
      element: "header",
      handler: "hover",
    },
    on: {
      "open-dropdown": _vm.onOpenDropdown,
      "close-dropdown": _vm.onCloseDropdown,
    },
    scopedSlots: _vm._u([
      {
        key: "before-nav",
        fn: function () {
          return [
            _c("li", { staticClass: "vsm-section logo-section" }, [
              _c("img", {
                attrs: {
                  src: "https://vuejs.org/images/logo.png",
                  alt: "My Logo",
                },
              }),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function ({ item }) {
          return [
            _c("div", { staticClass: "wrap-content" }, [
              _c("div", { staticClass: "wrap-content__block" }, [
                _vm._v("Header: " + _vm._s(item.title)),
              ]),
              _c(
                "div",
                { staticClass: "wrap-content__item" },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item-group",
                        { attrs: { color: "primary" } },
                        _vm._l(item.content, function (nItem, i) {
                          return _c(
                            "v-list-item",
                            { key: i, attrs: { to: nItem.link } },
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-play")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(nItem.title)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
      },
      {
        key: "after-nav",
        fn: function () {
          return [
            _c("li", { staticClass: "vsm-section vsm-mob-hide" }, [
              _c("button", [_vm._v("My Button")]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }